import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CloseIcon from '@material-ui/icons/Close';
// import AfitdTextField from './AfitdTextField';

// import { withStyles } from '@material-ui/core/styles';
// import cx from 'clsx';
// import _map from 'lodash/map';
// import _capitalize from 'lodash/capitalize';
import _size from 'lodash/size';
import _debounce from 'lodash/debounce';
import _isArray from 'lodash/isArray';
import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';

const styles = theme => ({
    tag: {
        background: '#F0F2F6',
        borderRadius: 4,
        '& .MuiChip-deleteIcon': { color: 'rgba(17, 30, 20, 0.4)' },
    },
    // test inputNotchedOutline border styles
    inputRoot: {
        '&$inputFocused $inputNotchedOutline': {
            borderColor: `${theme.palette.secondary.main} !important`,
        },
    },
    inputFocused: {},
    inputNotchedOutline: {
        borderWidth: '2px',
    },
});

// const defaultStyle = { width: '100%', padding: 0, margin: 0 };
const defaultFilter = createFilterOptions();
//createFilterOptions({ limit: 10 });
const defaultGetOptionLabel = option => option;

const AfitdAutocompleteLite = props => {
    const {
        classes,
        styles,
        isMulti = false,
        multiple = false,
        // style = defaultStyle,
        // options,
        // filterOptions = defaultFilter,
        // getOptionLabel = defaultGetOptionLabel,
        isClearable = true,
        disableClearable,
        placeholder: placeholderProp,
        value,
        error,
        onSuggestionsFetchRequested,
        ...otherProps
    } = props;

    let placeholder = placeholderProp;
    if ((_isArray(value) && !_isEmpty(value)) || (!_isArray(value) && !_isNil(value))) {
        placeholder = '';
    }

    // debounce onSuggestionsFetchRequested() for 500ms so it won't fire until the typing pause/top for half a second
    // const debouncedHandleChangeInput = useCallback(
    //     _debounce(value => {
    //         if (onSuggestionsFetchRequested) {
    //             if (_size(value) >= 2) {
    //                 onSuggestionsFetchRequested(value);
    //             } else {
    //                 onSuggestionsFetchRequested();
    //             }
    //         }
    //     }, 500),
    //     [],
    // );
    const debouncedHandleChangeInput = _debounce(value => {
        if (onSuggestionsFetchRequested) {
            if (_size(value) >= 2) {
                onSuggestionsFetchRequested(value);
            } else {
                onSuggestionsFetchRequested();
            }
        }
    }, 500);

    // handle the input onchange
    const handleChangeInput = evt => {
        const value = evt.target.value;

        debouncedHandleChangeInput(value);
    };

    const InputProps = {
        classes: {
            root: classes.inputRoot,
            focused: classes.inputFocused,
            notchedOutline: classes.inputNotchedOutline,
        },
    };

    return (
        <Autocomplete
            ChipProps={{
                deleteIcon: <CloseIcon />,
            }}
            styles={styles}
            classes={{ tag: classes.tag }}
            // autoComplete
            selectOnFocus
            autoHighlight
            // autoSelect
            // filterSelectedOptions
            disableClearable={isClearable === false || disableClearable}
            // options={options}
            filterOptions={defaultFilter}
            getOptionLabel={defaultGetOptionLabel}
            multiple={isMulti || multiple}
            renderInput={params => {
                // override some of the CSS classes
                const InputPropsParam = params.InputProps;
                const inputPropsParam = params.inputProps;
                return (
                    <TextField
                        color="secondary"
                        variant="outlined"
                        placeholder={placeholder}
                        {...params}
                        error={error}
                        onChange={handleChangeInput}
                        InputProps={{ ...InputPropsParam, ...InputProps, autocomplete: 'new-password' }}
                        inputProps={{ ...inputPropsParam, autocomplete: 'new-password' }}
                    />
                );
            }}
            value={value}
            {...otherProps}
        />
    );
};

// export default AfitdAutocompleteLite;
export default withStyles(styles)(AfitdAutocompleteLite);
